<div>
  <lib-gung-accordion>
    <lib-gung-accordion-item [collapsed]="false">
      <ng-template libGungAccordionHeader>{{ 'WITHOUT_SPECIFIC_STEP' | translate }}</ng-template>
      <ng-template libGungAccordionBody>
        <div class="mb-1">
          <input placeholder="Input order context id here" type="text" class="form-control" [(ngModel)]="context" />
        </div>
        <div>
          <button type="button" class="btn btn-primary" translate (click)="sendOrderContext()">SEND</button>
          <i *ngIf="loading" class="fa fa-spinner fa-spin fa-lg"></i>
        </div>
      </ng-template>
    </lib-gung-accordion-item>
    

  </lib-gung-accordion>

  <pre *ngIf="this.error">
        {{ error | json }}
    </pre
  >
  <pre *ngIf="data">
        {{ data | json }}
    </pre
  >
</div>
